var _excluded = ["width", "hiddenAbove", "hiddenBelow", "flex"],
    _excluded2 = ["children", "width", "hiddenAbove", "hiddenBelow", "flex"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React, { Children } from "react";
import styled, { css } from "styled-components";
import { map } from "../breakpoint";
import { validBreakpointValues } from "@nib-components/theme";
import { flexWidthsPropTypeMap, mapFlexWidths } from "../utils";
import { Hidden } from "../Hidden"; // eslint-disable-next-line @typescript-eslint/no-unused-vars

var ColumnWrapper = styled(function (_ref) {
  var width = _ref.width,
      hiddenAbove = _ref.hiddenAbove,
      hiddenBelow = _ref.hiddenBelow,
      flex = _ref.flex,
      rest = _objectWithoutProperties(_ref, _excluded);

  return hiddenAbove || hiddenBelow ? /*#__PURE__*/React.createElement(Hidden, _extends({
    above: hiddenAbove,
    below: hiddenBelow
  }, rest)) : /*#__PURE__*/React.createElement("div", rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  min-width: 0;\n\n  ", ";\n\n  ", "\n"])), function (_ref2) {
  var flex = _ref2.flex;
  return flex && "\n    display: flex;\n    width: 100%;\n  ";
}, function (_ref3) {
  var width = _ref3.width;
  return width ? map(width, function (val) {
    return val === "content" || val === "1" ? "\n              flex: 0 0 auto;\n              width: ".concat(val === "content" ? "auto" : "100%", ";\n            ") : css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                flex: 0 0 ", "%;\n                width: 100%;\n              "])), mapFlexWidths(val));
  }) : css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          width: 100%;\n        "])));
});
export var ColumnChild = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref4) {
  var flex = _ref4.flex;
  return flex && "\n    display: flex;\n    width: 100%;\n  ";
});
export var Column = function Column(_ref5) {
  var children = _ref5.children,
      width = _ref5.width,
      hiddenAbove = _ref5.hiddenAbove,
      hiddenBelow = _ref5.hiddenBelow,
      _ref5$flex = _ref5.flex,
      flex = _ref5$flex === void 0 ? false : _ref5$flex,
      otherProps = _objectWithoutProperties(_ref5, _excluded2);

  return /*#__PURE__*/React.createElement(ColumnWrapper, _extends({
    width: width,
    hiddenAbove: hiddenAbove,
    hiddenBelow: hiddenBelow,
    flex: flex
  }, otherProps), Children.map(children, function (child) {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      return /*#__PURE__*/React.createElement(ColumnChild, {
        flex: flex
      }, child);
    }

    return null;
  }));
};
Column.displayName = "Column";